import { Eye_1Icon } from "vega-icons";

import { type RoleNew } from "@vega-api/generated/types/roleNew";
import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { useBoolean } from "@vega-core/hooks/useBoolean";

import { ContextRolePermissionsModal } from "./ContextRolePermissionsModal";

type Props = {
  subjectName: string;
  role: RoleNew;
  contextRoles: RoleNew[];
  subjectId: string;
};

export const RoleDetails = ({ role, contextRoles, subjectName }: Props) => {
  const isOpen = useBoolean(false);

  return (
    <>
      <ThemedButton
        dataTestId="view-role-details"
        icon={
          <Eye_1Icon className="text-text/secondary hover:text-text/interactive" />
        }
        onClick={isOpen.setTrue}
        variant="tertiary"
      />
      <ContextRolePermissionsModal
        contextRoles={contextRoles}
        onClose={isOpen.setFalse}
        open={isOpen.value}
        role={role}
        subjectName={subjectName}
      />
    </>
  );
};
